<template>
  <section>
    <v-row justify="end">
      <v-col sm="5" cols="5">
        <v-menu
          ref="menu1"
          v-model="menuFrom"
          :close-on-content-click="false"
          :nudge-right="10"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFrom"
              label="Date From"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateFrom"
            @input="menuFrom = false"
            :min="propDateMin ? propDateMin : null"
            :max="propDateMax ? propDateMax : dateTo"
            reactive
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col sm="5" cols="5">
        <v-menu
          v-model="menuTo"
          :close-on-content-click="false"
          :nudge-right="10"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateTo"
              label="Date To"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateTo"
            @input="menuTo = false"
            :min="propDateMin ? propDateMin : dateFrom"
            :max="propDateMax ? propDateMax : null"
            reactive
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  props: {
    propDateFrom: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    },
    propDateTo: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    },
    propDateMin: {
      type: String,
      default: undefined
    },
    propDateMax: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      menuTo: false,
      menuFrom: false,
      format: 'DD/MM/YYYY'
    }
  },
  computed: {
    dateFrom: {
      get() {
        return this.propDateFrom
      },
      set(val) {
        this.$emit('dateFromSelected', val)
      }
    },
    dateTo: {
      get() {
        return this.propDateTo
      },
      set(val) {
        this.$emit('dateToSelected', val)
      }
    }
  }
}
</script>
